import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Function for fetching Intercom hmac
 */
@Injectable()
export class IntercomService {

  /**
   * Default constructor
   * @param {HttpClient} http - Angular Http Client
   */
  constructor(private http: HttpClient) {
  }


  /**
   * Fetch Intercom hmac
   * @returns {Observable<any>}
   */
  public getIntercomHMAC(email: string): Promise<any> {
    return this.http.get<any>(environment.regoApiURL + 'intercom/' + email).toPromise();
  }

}
